import { DropdownButton } from "../../toolbar-buttons";
import style from "./mindmap-org-chart-color-picker.module.css";
import { ColorsSelection } from "frontend/icons/orgchart-colors-selection";
import { useEffect, useState } from "react";

export default function MindmapOrgChartColorPicker({
  value,
  onChange,
  tooltip,
}: {
  value: any;
  onChange: (value: string) => void;
  tooltip?: string;
}) {
  const items = value as { id: string; title: string; selected: boolean; value: { color: string } }[];
  function renderColorPopup() {
    return (
      <>
        <div className={style.colorDropdownContainer}>
          <div className={style.title}>Color code by:</div>
          <CustomRadioButtons items={items} onChange={onChange}></CustomRadioButtons>
        </div>
      </>
    );
  }
  return (
    <DropdownButton
      tooltip={tooltip ?? "Change color"}
      renderPopup={renderColorPopup}
      className={style.arrowBackground}
    >
      <ColorsSelection size={20} />
    </DropdownButton>
  );
}

const CustomRadioButtons = ({
  items,
  onChange,
}: {
  items: { id: string; title: string; selected: boolean; value: { color: string } }[];
  onChange: (value: string) => void;
}) => {
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const selectedItem = items.find((item) => item.selected);
    setSelectedOption(selectedItem?.id || "");
  }, []);

  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.id);
    onChange(event.target.id);
  };

  function handleClickOnButton(id: string) {
    setSelectedOption(id);
    onChange(id);
  }

  const icon = (selected: boolean) => {
    if (selected) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          style={{ marginTop: "3px" }}
        >
          <circle cx="7.78571" cy="7.78571" r="6.78571" fill="#123458" stroke="#1A73FF" />
          <circle cx="7.78575" cy="7.78599" r="4.24107" fill="#1A73FF" />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          style={{ marginTop: "3px" }}
        >
          <circle cx="8" cy="8" r="7" fill="#355270" stroke="#657E9A" />
        </svg>
      );
    }
  };

  return (
    <>
      {items.map((item) => (
        <div
          key={item.id}
          style={{
            display: "flex",
            marginRight: "5px",
            alignItems: "center",
            height: "25px",
          }}
          onClick={() => handleClickOnButton(item.id)}
        >
          <span id={item.id} style={{ marginRight: "5px" }}>
            {icon(item.id === selectedOption)}
          </span>
          <input
            type="radio"
            id={item.id}
            name="radio-option"
            checked={item.id === selectedOption}
            onChange={handleOptionChange}
            style={{ display: "none" }}
          />
          <label htmlFor={item.id}>{item.title}</label>
        </div>
      ))}
    </>
  );
};
